import { AD_BANNER_CLIP } from '../video_player/ad_banner_clip'
import { trackEvent } from '../util/analytics'
import { loadPlayer } from '../util/load_player'
import { whenInView } from 'shared/javascripts/util/in_view'

interface VideoAdData {
  adServerOptions: any
  site: string
  playerType?: string
  adUnit?: string
  startInView?: boolean
}

function isRendered(element: HTMLElement): boolean {
  return element.getClientRects().length > 0
}

up.compiler(
  '[data-video-ad]',
  (
    element: HTMLElement,
    { adServerOptions, site, playerType, adUnit = 'banner', startInView = false }: VideoAdData,
  ) => {
    function hideVideoAdBanner(): void {
      element.classList.add('-no-ad-or-error')
    }

    if (!isRendered(element)) {
      hideVideoAdBanner()
      return
    }

    function startAd(): () => void {
      const playerContainer = element.querySelector<HTMLElement>('[data-player--container]')!
      const { playerPromise, destroyPlayer } = loadPlayer(playerContainer, {
        showAds: true,
        isVideoAdBanner: true,
        playerType: playerType || 'banner',
        site,
        adUnit,
      })

      const randomId = Math.floor(Math.random() * 100000).toString()
      element.setAttribute('data-video-ad-id', randomId)

      void playerPromise.then((player) => {
        trackEvent('player.init', { video: AD_BANNER_CLIP })

        player.loadVideo(AD_BANNER_CLIP, adServerOptions)
        void player.playWhenReady()
      })

      up.on(playerContainer, 'app:player:noAdReceived', hideVideoAdBanner)
      up.on(playerContainer, 'app:player:mediaError', hideVideoAdBanner)

      return () => {
        void destroyPlayer()
      }
    }

    if (!startInView) {
      return startAd()
    }

    let stopAd: (() => void) | undefined
    const stopWaiting = whenInView(element, () => {
      stopAd = startAd()
    })

    return () => {
      stopWaiting()
      stopAd?.()
    }
  },
)
